// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-panel {
  background-color: var(--headerBackground);
  color: var(--headerColor);
  position: absolute;
  top: 0px;
  left: 0px;
  height: 36px;
  width: 100%;
  text-align: center;
  line-height: 36px;
  border-bottom: 1px solid var(--headerBorder);
}
.header-panel mat-icon {
  display: inline-block;
  vertical-align: text-top;
}

.work-panel {
  position: absolute;
  top: 37px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: var(--workPanelBackground);
}
.work-panel .container {
  display: flex;
  flex-direction: column;
  min-width: 300px;
  position: absolute;
  bottom: 0px;
  top: 0px;
  left: 0px;
  right: 0px;
}
.work-panel .mat-table {
  overflow: auto;
  /* min-width: 1560px; */
}
.work-panel .mat-row {
  min-height: 40px;
  height: 43px;
}
.work-panel .mat-cell {
  font-size: 13px;
}
.work-panel .mat-header-row {
  top: 0;
  position: sticky;
  z-index: 1;
}
.work-panel .mat-header-cell {
  font-size: 15px;
}
.work-panel .mat-column-select {
  overflow: visible;
  flex: 0 0 100px;
}
.work-panel .mat-column-index {
  overflow: visible;
  flex: 0 0 100px;
}
.work-panel .mat-column-name {
  flex: 0 0 200px;
}
.work-panel .mat-column-description {
  flex: 2 1 250px;
}`, "",{"version":3,"sources":["webpack://./src/app/users/users-roles/users-roles.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/users/users-roles/users-roles.component.scss"],"names":[],"mappings":"AAAA;EACI,yCAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,4CAAA;ACCJ;ADCI;EACI,qBAAA;EACA,wBAAA;ACCR;;ADGA;EACI,kBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,4CAAA;ACAJ;ADEI;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;ACAR;ADGI;EACI,cAAA;EACA,uBAAA;ACDR;ADII;EACI,gBAAA;EACA,YAAA;ACFR;ADKI;EACI,eAAA;ACHR;ADMI;EACI,MAAA;EACA,gBAAA;EACA,UAAA;ACJR;ADQI;EACI,eAAA;ACNR;ADSI;EACI,iBAAA;EACA,eAAA;ACPR;ADUI;EACI,iBAAA;EACA,eAAA;ACRR;ADWI;EACI,eAAA;ACTR;ADYI;EACI,eAAA;ACVR","sourcesContent":[".header-panel {\n    background-color: var(--headerBackground);\n    color: var(--headerColor);\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    height: 36px;\n    width: 100%;\n    text-align: center;\n    line-height: 36px;\n    border-bottom: 1px solid var(--headerBorder);\n\n    mat-icon {\n        display: inline-block;\n        vertical-align: text-top;\n    }\n}\n\n.work-panel {\n    position: absolute;\n    top: 37px;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    background-color: var(--workPanelBackground);\n\n    .container {\n        display: flex;\n        flex-direction: column;\n        min-width: 300px;\n        position: absolute;\n        bottom: 0px;\n        top: 0px;\n        left:0px;\n        right:0px;\n    }\n\n    .mat-table {\n        overflow: auto;\n        /* min-width: 1560px; */\n    }\n      \n    .mat-row {\n        min-height: 40px;\n        height: 43px;\n    }\n    \n    .mat-cell {\n        font-size: 13px;\n    }\n    \n    .mat-header-row {\n        top: 0;\n        position: sticky;\n        z-index: 1;\n    }\n    \n    \n    .mat-header-cell {\n        font-size: 15px;\n    }\n    \n    .mat-column-select {\n        overflow: visible;\n        flex: 0 0 100px;\n    }\n    \n    .mat-column-index {\n        overflow: visible;\n        flex: 0 0 100px;\n    }\n    \n    .mat-column-name {\n        flex: 0 0 200px;\n    }\n    \n    .mat-column-description {\n        flex: 2 1 250px;\n    }\n}\n\n",".header-panel {\n  background-color: var(--headerBackground);\n  color: var(--headerColor);\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  height: 36px;\n  width: 100%;\n  text-align: center;\n  line-height: 36px;\n  border-bottom: 1px solid var(--headerBorder);\n}\n.header-panel mat-icon {\n  display: inline-block;\n  vertical-align: text-top;\n}\n\n.work-panel {\n  position: absolute;\n  top: 37px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n  background-color: var(--workPanelBackground);\n}\n.work-panel .container {\n  display: flex;\n  flex-direction: column;\n  min-width: 300px;\n  position: absolute;\n  bottom: 0px;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n}\n.work-panel .mat-table {\n  overflow: auto;\n  /* min-width: 1560px; */\n}\n.work-panel .mat-row {\n  min-height: 40px;\n  height: 43px;\n}\n.work-panel .mat-cell {\n  font-size: 13px;\n}\n.work-panel .mat-header-row {\n  top: 0;\n  position: sticky;\n  z-index: 1;\n}\n.work-panel .mat-header-cell {\n  font-size: 15px;\n}\n.work-panel .mat-column-select {\n  overflow: visible;\n  flex: 0 0 100px;\n}\n.work-panel .mat-column-index {\n  overflow: visible;\n  flex: 0 0 100px;\n}\n.work-panel .mat-column-name {\n  flex: 0 0 200px;\n}\n.work-panel .mat-column-description {\n  flex: 2 1 250px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
